import { createReducer, createNextState } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  fetchAPRSuccessResponse,
  fetchIllustrationSuccessResponse,
  resetIllustrationData,
  setSelectedLoanInfo,
  saveOldIllustrationDataForDIP
} from 'actionCreators/calculator';

function mapProductArray(productArray) {
  return productArray.map((product) => {
    return {
      ...(product.term && { term: product.term }),
      ...(product.rate && { rate: product.rate }),
      min: product.minimum_amount,
      max: product.maximum_amount
    };
  });
}

function mapPreAssessedArray(productArray) {
  const interest = productArray.sort((a, b) => a.high_limit - b.high_limit);

  return interest.map((product, index) => {
    return {
      min: index === 0 ? 0 : interest[index - 1].high_limit + 1,
      max: product.high_limit,
      rate: product.rate
    };
  });
}

const productReducer = createReducer({
  loaded: false
}, (builder) => {
  builder.addCase(fetchAPRSuccessResponse, (state, action) => {
    const {
      product: { band, code, limits_cb, limits_yb, rep_example_cb, rep_example_yb, term }
    } = action.payload;
    return {
      ...state,
      loaded: true,
      band,
      code,
      CB: mapProductArray(limits_cb),
      YB: mapProductArray(limits_yb),
      repExampleCB: rep_example_cb[0],
      repExampleYB: rep_example_yb[0],
      repExampleData: {
        CB: mapProductArray(limits_cb),
        YB: mapProductArray(limits_yb),
        terms: mapProductArray(term)
      }
    };
  });
});

const illustrationReducer = createReducer({
  loaded: false,
  data: [],
  repIllustrationData: null,
  oldIllustrationDataForDIP: null
}, (builder) => {
  builder.addCase(fetchIllustrationSuccessResponse, (state, action) => {
    const { term, apr, loanAmount, repExampleAmount, response } = action.payload;

    if (!repExampleAmount) {
      return createNextState(state, (draft) => {
        const itemExists =
          draft && draft.data.some((item) => item.term === parseInt(term) && item.apr === apr);
        draft.loaded = true;
        if (!itemExists) {
          draft.data.push({
            term: parseInt(term),
            illustrationData: response.illustration,
            apr,
            loanAmount
          });
        }
        return draft;
      });
    } else {
      return {
        ...state,
        loaded: true,
        repIllustrationData: {
          term: parseInt(term),
          illustrationData: response.illustration,
          apr,
          loanAmount
        }
      };
    }
  });

  builder.addCase(resetIllustrationData, (state, action) => {
    return {
      ...state,
      loaded: false,
      data: action.payload
    };
  });

  builder.addCase(saveOldIllustrationDataForDIP, (state, action) => {
    state.oldIllustrationDataForDIP = action.payload;
  });
});

const selectedLoanInfoReducer = createReducer({}, (builder) => {
  builder.addCase(setSelectedLoanInfo, (state, action) => {
    return {
      ...action.payload
    };
  });
});

const calculatorReducer = combineReducers({
  product: productReducer,
  illustration: illustrationReducer,
  selectedLoanInfo: selectedLoanInfoReducer
});

export { calculatorReducer };
